import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    done: 'Done!',
    doneDescription:
      '{inAmount} {stakeToken} was successfully unstaked!<br /> You can claim {outAmount} {mainToken} in {period} {period, plural, =1 {day} other {days}} on the Withdrawal tab.',
    doneFlashDescription:
      '{inAmount} {stakeToken} unstaked successfully!<br />{outAmount} {mainToken} was sent to your wallet.',
    buttonText: 'OK',
  },
};
